import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

const LinkButton = styled(Link)<{ variant: 'blue' | 'red' | 'blueLight' | 'pink' }>`
  display: inline-block;
  font-size: 16px;
  line-height: 20px;
  padding: 7px 25px;
  border-radius: 30px;
  border: none;
  color: #fff;
  text-decoration: none;
  font-weight: bold;
  box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.25);
  :focus,
  :hover {
    opacity: ${({ theme }) => theme.button.opacity.hover};
    color: #fff;
    text-decoration: none;
    box-shadow: none;
  }

  ${({ variant }) =>
    ({
      blue: css`
        background: #1c569d;
        border: 1px solid #1c569d;
      `,
      red: css`
        background: #dc551c;
        border: 1px solid #dc551c;
      `,
      blueLight: css`
        background: #3468a7;
        border: 1px solid #3468a7;
      `,
      pink: css`
        background: #f86b6c;
        border: 1px solid #f86b6c;
      `,
    }[variant])}
`;

export default LinkButton;
